import { dataShieldCheckSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldCheckSolid = /*#__PURE__*/createIcon(dataShieldCheckSolid)
export default IconShieldCheckSolid
